import variance from 'ml-array-variance';

function standardDeviation(values) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Math.sqrt(variance(values, options));
}

export default standardDeviation;
